<div class="filters">
  <form>
    <ion-searchbar
      #searchbar
      mode="ios"
      inputmode="search"
      enterkeyhint="search"
      [placeholder]="searchBarText"
      [debounce]="600"
      (ionChange)="searchValueChange($event)"
    ></ion-searchbar>
  </form>
  @if (isNeedFiltersButton) {
    <app-filters-button
      [dataForFilters]="dataForFilters"
      [excludeSingleFiltersOptions]="excludeSingleFiltersOptions"
    ></app-filters-button>
  }
</div>
